module.exports = __webpack_public_path__ + "assets/img/05.8a38d404.png";